module.exports = __webpack_public_path__ + "img/rollcall_3.5fdab0d0.png";